export default "__VITE_ASSET__C3kTKD6T__"